import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IDiscountTemplatesDto } from 'src/app/models/backend';
import { ControlItem } from 'src/app/models/frontend';
import { LocationsService } from '../../locations/locations.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { DiscountTemplatesService } from '../discount-templates.service';
import { take } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-discount-template',
  templateUrl: './edit-discount-template.component.html',
  styleUrls: ['./edit-discount-template.component.scss']
})
export class EditDiscountTemplateComponent {
  errors: string[] | null = [];
  eventForm: FormGroup;
  location: IDiscountTemplatesDto
  countries: any;
  countriesData: ControlItem[] = []

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder,
    public discountService: DiscountTemplatesService, public router: Router,
    private toastr:ToastrService
  ) {
    console.log(this.discountService.id)
    if (this.discountService.id == null || this.discountService.id == undefined) {
      this.router.navigateByUrl("locations")
    }
    
  }
  ngOnInit(){
    this.discountService.GetDiscountTemplate(this.discountService.id)
      .pipe(take(1))
      .subscribe({

        next: r => this.SetValuetoForm(r),
        // error: e => this.errors = e.error?.errors || [e.error?.message]
        error: e => {
          if ( this.errors = e.error?.errors || [e.error?.message]) {
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
  }

  SetValuetoForm(location: IDiscountTemplatesDto) {
    this.discountService.id = null
    console.log(location)
    this.eventForm = this.fb.group({
      Id: [location.id, [Validators.required]],
      Name: [location.name, [Validators.required, Validators.maxLength(100)]],
     });
  }
  onSubmit() {
    this.errors = [];
    if (!this.eventForm.valid) return this.eventForm.markAllAsTouched();
    if (this.errors.length > 0) return;

    this.discountService.UpdateDiscountTemplate(this.eventForm.value)
      .subscribe({
        next: r => {
          // Swal.fire('Updated', '', 'success')
          this.toastr.success('Updated','Success');
          this.activeModal.close({ refresh: true });
        },
        // error: e => this.errors = e.error?.errors || [e.error?.message]
        error:e=>
        {
          if ( this.errors = e.error?.errors || [e.error?.message]) {
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
  }
  cancel() {
    this.discountService.id = null
    this.router.navigateByUrl("categories")
  }

}
